<template>
    <layout-authenticated>
        <v-breadcrumbs :items="breadcrumb"></v-breadcrumbs>
        <h2>{{ $t('warehouses.warehouses') }}</h2>
        <warehouses-table-component/>
    </layout-authenticated>
</template>

<script>
import WarehousesTableComponent from "@/components/admin/tables/WarehousesTableComponent";
import LayoutAuthenticated from "@/layouts/LayoutAuthenticated";

export default {
    name: 'Warehouses',
    components: {LayoutAuthenticated, WarehousesTableComponent},
    computed: {
        breadcrumb() {
            return [
                {
                    text: this.$t('app.administration'),
                    href: '/admin'
                },
                {
                    text: this.$t('warehouses.warehouses'),
                    href: '/admin/warehouses',
                    disabled: true
                }
            ];
        }
    }
}
</script>
